/**
 * Funciones de transformación de datos API ↔ Tabla
 * Reutilizable en múltiples páginas (Clients, Personal, Customer, Orders)
 */

/**
 * Transforma cliente desde API al formato de tabla
 * @param {object} apiClient - Datos del cliente desde API
 * @returns {object} Cliente con formato para mostrar en tabla
 */
export const transformClientToTable = (apiClient) => ({
    id: apiClient.id,
    client_name: apiClient.name,
    first_lastname: apiClient.first_lastname || '',
    second_lastname: apiClient.second_lastname || '',
    email: apiClient.email,
    phone: apiClient.phone,
    second_phone: apiClient.second_phone || '',
    address: apiClient.address,
    rfc: apiClient.RFC,
    company_name: apiClient.company_name || '',
});

/**
 * Transforma cliente desde formulario al formato de API
 * @param {object} formData - Datos del formulario
 * @returns {object} Cliente con formato para enviar al API
 */
export const transformClientToAPI = (formData) => ({
    name: formData.client_name,
    first_lastname: formData.first_lastname,
    second_lastname: formData.second_lastname || '',
    email: formData.email,
    address: formData.address,
    phone: formData.phone,
    RFC: formData.RFC || '',
    company_name: formData.company_name || '',
    second_phone: formData.second_phone || '',
});

/**
 * Transforma empleado desde API al formato de tabla
 */
export const transformEmployeeToTable = (apiEmployee) => ({
    employee_id: apiEmployee._id,
    employee_name: `${apiEmployee.details.name} ${apiEmployee.details.last_name}`,
    email: apiEmployee.email,
    phone: apiEmployee.details.phone_number || '',
    role: apiEmployee.role === 'admin' ? 'Admin' : 'Technician',
    nss: apiEmployee.details.NSS,
    curp: apiEmployee.details.CURP || '',
    rfc: apiEmployee.details.RFC || '',
    address: apiEmployee.details.address || '',
});

/**
 * Transforma proveedor desde API al formato de tabla
 */
export const transformSupplierToTable = (apiSupplier) => ({
    id: apiSupplier.id,
    supplier_name: apiSupplier.name,
    email: apiSupplier.email,
    phone: apiSupplier.phone || '',
    address: apiSupplier.address || '',
    contact_person: apiSupplier.contact_person || '',
});

/**
 * Transforma empleado desde formulario al formato de API
 */
export const transformEmployeeToAPI = (formData) => ({
    email: formData.email,
    role: formData.role,
    allowed_actions: [],
    details: {
        name: formData.employee_name.split(' ')[0],
        last_name: formData.employee_name.split(' ').slice(1).join(' ') || 'Apellido',
        CURP: formData.curp || '',
        NSS: formData.nss,
        phone_number: formData.phone,
        address: formData.address || '',
        RFC: formData.rfc || '',
    },
});